<template>
  <v-container
    id="extended-forms"
    fluid
    tag="section"
  >
    <validation-observer
      v-slot="{ handleSubmit }"
    >
      <form @submit.prevent="handleSubmit(submitForm)">
        <v-row>
          <v-col cols="12">
            <base-material-card
              class="pa-6"
              color="success"
              icon="mdi-chevron-triple-right"
              :title="title"
            >
              <v-skeleton-loader
                class="mx-auto"
                max-width="300"
                type="card"
                :loading="loadingIncomeCategory"
              >
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required|max:50"
                          name="incomeCategory.name"
                        >
                          <v-text-field
                            v-model="incomeCategory.name"
                            :error-messages="errors"
                            color="secondary"
                            :label="$t('fields.incomeCategory.name')"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <div class="pa-3 text-center">
                  <v-btn
                    color="warning"
                    default
                    @click="goToList"
                  >
                    {{ $t('cancel') }}
                  </v-btn>
                  <v-btn
                    color="success"
                    default
                    type="submit"
                    :loading="loadingSave"
                  >
                    {{ $t("save") }}
                  </v-btn>
                </div>
              </v-skeleton-loader>
            </base-material-card>
          </v-col>
        </v-row>
      </form>
    </validation-observer>
    <base-material-snackbar
      v-model="showErrorMessage"
      type="error"
      v-bind="{
        ['top']: true,
        ['center']: true,
        ['vertical']: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </v-container>
</template>

<script>
  import { repositoryFactory } from '@/api/repositoryFactory'
  const incomeCategoriesRespository = repositoryFactory.get('incomeCategories')

  export default {
    inject: ['theme'],
    name: 'IncomeCategoryCrud',
    $_veeValidate: {
      validator: 'new',
    },
    data: () => ({
      incomeCategory: {

      },
      currencies: [],
      showErrorMessage: false,
      errorMessage: '',
      loadingIncomeCategory: false,
      loadingSave: false,
      formAction: null,
    }),
    computed: {
      title () {
        return this.formAction === 'add' ? this.$t('add-incomeCategory') : this.$t('modify-incomeCategory')
      },
    },
    mounted () {
      var self = this
      self.formAction = this.$route.params.id === 'add' ? 'add' : 'modify'

      if (self.formAction !== 'add') {
        self.loadingIncomeCategory = true
        var id = this.$route.params.id
        incomeCategoriesRespository.getById(id).then(response => {
          self.loadingIncomeCategory = false
          self.incomeCategory = Object.assign({}, response.data.data)
        }).catch(err => {
          self.loadingIncomeCategory = false
          alert(err)
        })
      }
    },
    methods: {
      submitForm (scope) {
        var self = this
        var data = {
          data: this.incomeCategory,
        }
        self.loadingSave = true
        if (self.formAction !== 'add') {
          incomeCategoriesRespository.updateIncomeCategory(data, this.incomeCategory.id).then(response => {
            if (response.data.isValid) {
              self.goToList()
            } else {
              self.showErrorMessage = true
              self.errorMessage = response.data.errorMessages[0]
            }
            self.loadingSave = false
          }).catch(err => {
            self.errorMessage = err
            self.showErrorMessage = true
            self.loadingSave = false
          })
        } else {
          incomeCategoriesRespository.addIncomeCategory(data).then(response => {
            if (response.data.isValid) {
              self.goToList()
            } else {
              self.showErrorMessage = true
              self.errorMessage = response.data.errorMessages[0]
            }
            self.loadingSave = false
          }).catch(err => {
            self.errorMessage = err
            self.showErrorMessage = true
            self.loadingSave = false
          })
        }
      },
      goToList () {
        this.$router.push({ name: 'incomeCategories' })
      },
    },
  }
</script>
